// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { logError } from './utils/logError'
import { setupCopyDelegation } from './utils/formatters'

loadFonts()

// Install the delegated click listener for 📋 copy buttons generated by
// formatAndLinkUrls (emails, file paths in table cells). Must be called once
// before any v-html content renders — main.js is the right place.
setupCopyDelegation();

const app = createApp(App)

// --- Global error telemetry ---
// Catches errors thrown inside Vue components (render, watchers, lifecycle)
// that no local try/catch ever sees.
app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue error]', info, err)
  const component =
    instance?.$options?.name || instance?.$?.type?.__name || 'unknown'
  logError(`vue:${info}`, err, { component })
}

// Promise rejections nothing awaited (fire-and-forget Firestore calls, etc.)
window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled rejection]', event.reason)
  logError('unhandledrejection', event.reason)
})

// Plain runtime errors outside Vue (event handlers in generated HTML, etc.)
window.addEventListener('error', (event) => {
  logError('window.onerror', event.error || event.message)
})

app.use(vuetify).mount('#app')